import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $, nothing as w } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { when as n } from '../../../../node_modules/lit-html/directives/when.js';
import '../nav-category/index.js';
import '../../atoms/featured-article/index.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import css_248z from './mega-menu-mobile.scss.js';

class MegaMenuMobile extends s {
    constructor() {
        super(...arguments);
        this.data = [];
        this.open = false;
        this.backText = 'Go back';
        this.goToButtonText = 'Go to:';
        this.selectedGroup = null;
        this.onKeydown = (e) => {
            if (e.key === 'Escape' && this.open) {
                this.emitClose();
            }
        };
        this.renderGroupToggle = (group, groupTitle, groupLink, groupControlId, hasItems) => {
            if (hasItems) {
                return $ `<button class="group-toggle" @click="${() => this.openGroup(group)}" aria-expanded="false" aria-controls="${groupControlId}"><span class="group-title">${groupTitle}</span> <span class="group-title__chevron" aria-hidden="true"><span class="material-symbols-outlined">chevron_right</span></span></button>`;
            }
            return $ `<a class="group-toggle" href="${groupLink}" @click="${() => this.onItemClick(group.link)}"><span class="group-title">${groupTitle}</span></a>`;
        };
    }
    connectedCallback() {
        super.connectedCallback();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.removeKeydown();
    }
    updated(changed) {
        if (changed.has('open')) {
            if (this.open) {
                this.addKeydown();
                requestAnimationFrame(() => {
                    const first = this.renderRoot.querySelector('button, a');
                    first === null || first === void 0 ? void 0 : first.focus();
                });
            }
            else {
                this.removeKeydown();
                this.selectedGroup = null;
            }
        }
        if (changed.has('selectedGroup') && this.selectedGroup) {
            requestAnimationFrame(() => {
                const firstLink = this.renderRoot.querySelector('.group-items a');
                firstLink === null || firstLink === void 0 ? void 0 : firstLink.focus();
            });
        }
    }
    addKeydown() {
        this.addEventListener('keydown', this.onKeydown);
    }
    removeKeydown() {
        this.removeEventListener('keydown', this.onKeydown);
    }
    emitClose() {
        this.dispatchEvent(new CustomEvent('close', { bubbles: true, composed: true }));
    }
    openGroup(group) {
        this.selectedGroup = group;
    }
    goBackToGroups() {
        this.selectedGroup = null;
    }
    onItemClick(link) {
        if (link && link !== '#') {
            // eslint-disable-next-line no-undef
            globalThis.location.assign(link);
            return;
        }
        this.emitClose();
    }
    renderSubItem(sub) {
        return $ `<li><a href="${sub.link || '#'}" @click="${() => this.onItemClick(sub.link)}">${sub.title}</a></li>`;
    }
    renderGotoLink(item) {
        if (!item.link || item.link === '#')
            return w;
        const gotoText = `${this.goToButtonText} ${item.title}`;
        return $ `<li><a class="accordion-list__redirect" href="${item.link}" @click="${() => this.onItemClick(item.link)}">${gotoText}</a></li>`;
    }
    handleAccordionToggle(e) {
        const clickedDetails = e.currentTarget;
        // Only close others if this one is being opened
        if (clickedDetails.open) {
            const allDetails = this.renderRoot.querySelectorAll('.accordion-item details');
            allDetails.forEach(detailsElement => {
                if (detailsElement !== clickedDetails && detailsElement.open) {
                    detailsElement.removeAttribute('open');
                }
            });
        }
    }
    renderItem(item) {
        var _a;
        if ((_a = item.items) === null || _a === void 0 ? void 0 : _a.length) {
            return $ `<div class="item accordion-item"><details @toggle="${this.handleAccordionToggle}"><summary class="accordion-summary" aria-expanded="false"><span class="item-title">${item.title}</span> <span class="material-symbols-outlined chevron" aria-hidden="true">chevron_right</span></summary><ul class="accordion-list">${this.renderGotoLink(item)} ${item.items.map((sub) => this.renderSubItem(sub))}</ul></details></div>`;
        }
        return $ `<div class="item"><a class="item-link item-title" href="${item.link || '#'}" @click="${() => this.onItemClick(item.link)}">${item.title}</a></div>`;
    }
    renderGroupItems() {
        var _a, _b, _c, _d, _e, _f;
        const group = this.selectedGroup;
        if (!group)
            return w;
        const withChildren = (_b = (_a = group.items) === null || _a === void 0 ? void 0 : _a.filter(item => { var _a; return (_a = item.items) === null || _a === void 0 ? void 0 : _a.length; })) !== null && _b !== void 0 ? _b : [];
        const withoutChildren = (_d = (_c = group.items) === null || _c === void 0 ? void 0 : _c.filter(item => { var _a; return !((_a = item.items) === null || _a === void 0 ? void 0 : _a.length); })) !== null && _d !== void 0 ? _d : [];
        const sortedItems = [...withChildren, ...withoutChildren];
        const hasNavCategory = !!((_e = this.selectedGroup) === null || _e === void 0 ? void 0 : _e.menuNavCategory);
        return $ `<div class="group-view ${hasNavCategory
            ? 'group-view--with-nav-category'
            : ''}" role="region" aria-label="${group.title}" slot="mobile-nav-items"><div class="group-items ${hasNavCategory
            ? 'group-items--with-nav-category'
            : ''}" id="group-${group.title}-items">${(_f = sortedItems.map(item => this.renderItem(item))) !== null && _f !== void 0 ? _f : w}</div></div>`;
    }
    renderFeaturedArticle() {
        var _a, _b;
        const featuredArticle = (_a = this.selectedGroup) === null || _a === void 0 ? void 0 : _a.featuredArticle;
        if (!featuredArticle)
            return w;
        return n((_b = this.selectedGroup) === null || _b === void 0 ? void 0 : _b.featuredArticle, () => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            return $ `<div class="featured-separator" aria-hidden="true"></div><featured-article .text="${(_a = featuredArticle === null || featuredArticle === void 0 ? void 0 : featuredArticle.text) !== null && _a !== void 0 ? _a : ''}" .linkText="${(_c = (_b = featuredArticle === null || featuredArticle === void 0 ? void 0 : featuredArticle.navLink) === null || _b === void 0 ? void 0 : _b.text) !== null && _c !== void 0 ? _c : ''}" .linkHref="${(_e = (_d = featuredArticle === null || featuredArticle === void 0 ? void 0 : featuredArticle.navLink) === null || _d === void 0 ? void 0 : _d.link) !== null && _e !== void 0 ? _e : ''}" .ariaLabel="${(_g = (_f = featuredArticle === null || featuredArticle === void 0 ? void 0 : featuredArticle.navLink) === null || _f === void 0 ? void 0 : _f.ariaLabel) !== null && _g !== void 0 ? _g : ''}" .isNoFollow="${(_j = (_h = featuredArticle === null || featuredArticle === void 0 ? void 0 : featuredArticle.navLink) === null || _h === void 0 ? void 0 : _h.isNoFollow) !== null && _j !== void 0 ? _j : false}" .target="${(_k = featuredArticle === null || featuredArticle === void 0 ? void 0 : featuredArticle.navLink) === null || _k === void 0 ? void 0 : _k.target}"></featured-article>`;
        });
    }
    renderNavCategory() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        if (!((_a = this.selectedGroup) === null || _a === void 0 ? void 0 : _a.menuNavCategory))
            return w;
        const navData = this.selectedGroup.menuNavCategory;
        return $ `<nav-category .heading="${(_b = navData.title) !== null && _b !== void 0 ? _b : ''}" .description="${(_c = navData.description) !== null && _c !== void 0 ? _c : ''}" .icon="${(_d = navData.categoryIcon) !== null && _d !== void 0 ? _d : ''}" .buttonText="${(_f = (_e = navData.cta) === null || _e === void 0 ? void 0 : _e.text) !== null && _f !== void 0 ? _f : ''}" .buttonHref="${(_h = (_g = navData.cta) === null || _g === void 0 ? void 0 : _g.link) !== null && _h !== void 0 ? _h : ''}" .ariaLabel="${(_k = (_j = navData.cta) === null || _j === void 0 ? void 0 : _j.ariaLabel) !== null && _k !== void 0 ? _k : ''}" .target="${(_l = navData.cta) === null || _l === void 0 ? void 0 : _l.target}" .isNoFollow="${(_m = navData.cta) === null || _m === void 0 ? void 0 : _m.isNoFollow}" .links="${(_o = navData.navLinks) !== null && _o !== void 0 ? _o : []}" .buttonId="${navData === null || navData === void 0 ? void 0 : navData.title}" .isCMSIcon="${(navData === null || navData === void 0 ? void 0 : navData.isCMSIcon) || false}">${this.renderGroupItems()}</nav-category>`;
    }
    renderGroupsList() {
        var _a;
        const getGroupControlId = (groupTitle) => `group-${groupTitle}-items`;
        const getGroupsListContent = (groupContent) => $ `<div class="group-row" role="listitem">${groupContent}</div>`;
        return $ `<div class="groups-list" role="list">${(_a = this.data) === null || _a === void 0 ? void 0 : _a.map(group => {
            var _a;
            const hasItems = (_a = group.items) === null || _a === void 0 ? void 0 : _a.length;
            const groupTitle = group.title;
            const groupLink = group.link || '#';
            const groupControlId = getGroupControlId(groupTitle);
            const groupContent = this.renderGroupToggle(group, groupTitle, groupLink, groupControlId, !!hasItems);
            return getGroupsListContent(groupContent);
        })}</div>`;
    }
    render() {
        var _a;
        const hasNavCategory = !!((_a = this.selectedGroup) === null || _a === void 0 ? void 0 : _a.menuNavCategory);
        const renderedGroupItems = this.selectedGroup && !hasNavCategory ? this.renderGroupItems() : w;
        const renderedGroupsList = this.selectedGroup
            ? w
            : this.renderGroupsList();
        const goBack = this.selectedGroup
            ? $ `<div class="panel-header"><button class="back" @click="${() => this.goBackToGroups()}" aria-label="${this.backText}"><span class="material-symbols-outlined chevron" aria-hidden="true">chevron_left</span> ${this.backText}</button></div>`
            : w;
        return $ `<div class="inner" aria-hidden="${this.open ? 'false' : 'true'}">${goBack} ${this.renderNavCategory()} ${renderedGroupItems} ${renderedGroupsList} ${this.renderFeaturedArticle()}<div class="global-nav-slot"><slot name="global-nav"></slot></div></div>`;
    }
}
MegaMenuMobile.styles = css_248z;
__decorate([
    e({ type: Array })
], MegaMenuMobile.prototype, "data", void 0);
__decorate([
    e({ type: Boolean, reflect: true })
], MegaMenuMobile.prototype, "open", void 0);
__decorate([
    e({ type: String })
], MegaMenuMobile.prototype, "backText", void 0);
__decorate([
    e({ type: String })
], MegaMenuMobile.prototype, "goToButtonText", void 0);
__decorate([
    t()
], MegaMenuMobile.prototype, "selectedGroup", void 0);
customElements.define('mega-menu-mobile', MegaMenuMobile);

export { MegaMenuMobile };
